module.exports = __webpack_public_path__ + "static/media/Spin.fdfa14d7.gif";